import { ref, onMounted, defineComponent } from 'vue'
import { useRouter } from 'vue-router'

import { axiosInstance } from 'src/boot/axios'
import SelectRolesImpl from 'src/components/VolunteerRegistration/SelectRolesImpl.vue'
import { VolunteerRoleSelection } from 'src/components/VolunteerRegistration/SelectRolesUtils'

import * as ilapi from 'src/composables/InleagueApiV1'

import { Client } from 'src/store/Client'
import { FormKit } from '@formkit/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBallotCheck } from '@fortawesome/pro-solid-svg-icons'
import { ContentChunk, Season, VolunteerDetails } from 'src/interfaces/InleagueApiV1'
import { assertNonNull } from 'src/helpers/utils'
import ContentChunkDisplay from '../Admin/ContentChunks/ContentChunkDisplay'
import { GlobalInteractionBlockingRequestsInFlight } from 'src/store/EventuallyPinia'
import { ContentChunkStore } from 'src/store/ContentChunkStore'

export default defineComponent({
  props: {
    seasonUID: { required: true, type: String },
    volunteerID: { required: true, type: String },
  },
  emits: ['roles-selected'],
  setup(props, context) {
    const router = useRouter()
    const volunteerDetails = ref<VolunteerDetails>()
    const contentChunk = ref<ContentChunk>()
    const season = ref<Season>()
    const ready = ref(false)
    const formValues = ref<VolunteerRoleSelection | undefined>(undefined)

    onMounted(async () => {
      await GlobalInteractionBlockingRequestsInFlight.withSpinner(async () => {
        volunteerDetails.value = await ilapi.getVolunteerDetails(
          axiosInstance,
          props.volunteerID,
          props.seasonUID
        )

        season.value = await Client.getSeasonByUidOrFail(
          props.seasonUID
        )

        contentChunk.value = await ContentChunkStore.getContentChunk(axiosInstance, {
          id: "VolunteerPrefsInstructions",
          interpolationArgs: {
            seasonName: season.value.seasonName
          }});

        ready.value = true
      })
    })

    function submit({selectRolesImpl: formData} : {selectRolesImpl: VolunteerRoleSelection}) {
      context.emit('roles-selected', formData)
    }

    return () => {
      if (!ready.value) {
        return null
      }

      // guaranteed non-null after onMounted
      assertNonNull(volunteerDetails.value)
      assertNonNull(season.value)
      assertNonNull(contentChunk.value)

      return <div>
        <div class="smx-auto w-full flex items-end">
          <h1 class="ml-2 mr-4 text-2xl self-start font-medium md:text-4xl">
            <FontAwesomeIcon class="mr-2" icon={faBallotCheck}/>
            {season.value.seasonName} Volunteer Preferences - {volunteerDetails.value.firstName} {volunteerDetails.value.lastName}
          </h1>
        </div>
        <ContentChunkDisplay
          class="mb-4 mt-2 font-lg ml-2"
          id={contentChunk.value.id} // TODO: this ID is redundant if we are passing in the contentChunkObj itself, yeah?
          contentChunkObj={contentChunk.value}
        />
        <FormKit type="form" onSubmit={submit} submit-label="Submit Volunteer Preferences">
          <SelectRolesImpl
            {...{
              name:"selectRolesImpl" // n.b. affects the name of data emitted from the form on submit
            }}
            volunteerID={props.volunteerID}
            seasonUID={props.seasonUID}
            volunteerDetails={volunteerDetails.value}
          />
        </FormKit>
      </div>
    }
  }
})
